<template>
  <div class="toast-stack" aria-live="polite">
    <article v-for="toast in toastApi.toasts" :key="toast.id" class="toast" :class="toast.kind">
      <span>{{ toast.message }}</span>
      <button class="toast-close" title="关闭" @click="toastApi.remove(toast.id)"><X :size="14" /></button>
    </article>
  </div>
</template>

<script setup lang="ts">
import { X } from "@lucide/vue";
import { useToast } from "../composables/useToast";

const toastApi = useToast();
</script>
